/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-expressions */
/* eslint-disable-no-extraneous-dependencies */
import React, { useEffect, useRef, useState } from "react";
import { RiDownloadLine, RiEditLine } from "react-icons/ri";
import { IoClose } from "react-icons/io5";
import { IoMdEye } from "react-icons/io";
import { toast } from "react-toastify";
import { MdOutlineCloudUpload } from "react-icons/md";
import { putMetodoPagamento } from "screens/perfilAutonomo/api/putMetodoPagamento";
import { TextInputMask } from "../TextInputMask";
import {
  MetodoPagamento,
  MetodoPagamentoOptions,
  type FileUploadI,
} from "../../utils";
import { rNS, BooleanOptions, COLORS } from "../../utils";
import { MAX_UPLOAD_SIZE } from "../FileUploadModal/utils";
import * as S from "./styles";
import * as Styles from "../modal.styles";
import { SelectComponent } from "../SelectComponent";
import { SecondaryButton } from "../secondaryButton.component";
import { PrimaryButton } from "../primaryButton.component";
import { Loading } from "../Loading";
import { TextInput } from "../TextInput";

const accept = "image/png, image/jpeg, image/jpg, application/pdf";

const uploadButtonContent = (
  <div
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      fontFamily: "Inter",
    }}
  >
    <p style={{ color: COLORS.primary500, fontSize: 16, fontWeight: 500 }}>
      Anexar
    </p>
    <MdOutlineCloudUpload size={20} />
  </div>
);

const defaultData = {
  metodoDePagamento: null,
  nomeDoBanco: null,
  agencia: null,
  contaCorrente: null,
  cnpj: null,
  razaoSocial: null,
  enderecoFiscal: null,
  possuiCreciJuridico: null,
  arquivoCreciJuridico: null,
  arquivoCNPJ: null,
};

const typeFiles = {
  arquivoCreciJuridico: "arquivoCreciJuridico",
  arquivoCNPJ: "arquivoCNPJ",
};

export const MetodoPagamentoModal = ({
  isOpen,
  onClose,
  user,
  authToken,
}: {
  isOpen: boolean;
  onClose: () => void;
  user: any;
  authToken: string;
}) => {
  const [currentFileUpload, setCurrentFileUpload] = useState<
    keyof typeof typeFiles | null
  >(null);
  const [saving, setSaving] = useState(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [data, setData] = useState<{
    metodoDePagamento: MetodoPagamento | null;
    nomeDoBanco: string | null;
    agencia: string | null;
    contaCorrente: string | null;
    cnpj: string | null;
    razaoSocial: string | null;
    enderecoFiscal: string | null;
    possuiCreciJuridico: boolean | null;
    arquivoCreciJuridico: FileUploadI | null;
    arquivoCNPJ: FileUploadI | null;
  }>(defaultData);

  useEffect(() => {
    if (isOpen) {
      const m = user?.autonomoMetodoDePagamento;
      setData({
        metodoDePagamento: m?.metodoDePagamento ?? null,
        nomeDoBanco: m?.nomeDoBanco ?? null,
        agencia: m?.agencia ?? null,
        contaCorrente: m?.contaCorrente ?? null,
        razaoSocial: m?.razaoSocial ?? null,
        cnpj: m?.cnpj ?? null,
        enderecoFiscal: m?.enderecoFiscal ?? null,
        possuiCreciJuridico:
          typeof m?.possuiCreciJuridico === "boolean"
            ? m?.possuiCreciJuridico
            : null,
        arquivoCreciJuridico: m?.arquivoCreciJuridico ?? null,
        arquivoCNPJ: m?.arquivoCNPJ ?? null,
      });
    } else {
      setCurrentFileUpload(null);
    }
  }, [isOpen]);

  const handleFileUpload = (property: keyof typeof typeFiles) => {
    setCurrentFileUpload(property);

    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const acceptedTypes =
        accept?.split(",").map((type: string) => type.trim()) ?? [];
      const isValidType = acceptedTypes.some(
        (type) =>
          file.type === type ||
          (type.includes("*") && file.name.endsWith(type.replace("*", "")))
      );

      if (!isValidType) {
        toast.error("Formato de arquivo inválido");
      } else if (file.size > MAX_UPLOAD_SIZE) {
        toast.error(
          `Tamanho do arquivo deve ser menor que ${
            MAX_UPLOAD_SIZE / 1024 / 1024
          }MB`
        );
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          const newFile = {
            nome: file.name,
            base64: String(reader?.result).split(",").pop() as string,
            contentType: file.type,
          };

          if (currentFileUpload) {
            setData((prev) => ({
              ...prev,
              [currentFileUpload]: newFile,
            }));
            setCurrentFileUpload(null);
          }

          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const download = async (fileUrl: string) => {
    try {
      const response = await fetch(fileUrl);
      if (!response.ok)
        throw new Error(`Error fetching file: ${response.statusText}`);

      const blob = await response.blob();
      const downloadUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = fileUrl.split("/").pop() ?? "download";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      toast.error("Erro ao baixar o arquivo");
      console.error("Download failed:", error);
    }
  };

  const handleFileActions = (fileUrl: string, action: "open" | "download") => {
    if (!fileUrl) {
      toast.error("URL do arquivo não encontrada");
      return;
    }
    if (action === "download") {
      download(fileUrl);
    } else {
      window.open(fileUrl);
    }
  };

  const resetMetodoPagamento = (novoMetodo?: MetodoPagamento) => {
    setData((prev) => ({
      ...defaultData,
      metodoDePagamento: novoMetodo ?? prev.metodoDePagamento,
    }));
  };

  const onSubmit = () => {
    setSaving(true);

    putMetodoPagamento({
      idAutonomo: user?.id,
      metodoDePagamento: data.metodoDePagamento,
      nomeDoBanco: data.nomeDoBanco,
      agencia: data.agencia,
      contaCorrente: data.contaCorrente,
      cnpj: data.cnpj,
      razaoSocial: data.razaoSocial,
      enderecoFiscal: data.enderecoFiscal,
      possuiCreciJuridico: data.possuiCreciJuridico,
      arquivoCreciJuridico: data.arquivoCreciJuridico,
      arquivoCNPJ: data.arquivoCNPJ,
      authToken: authToken ?? "",
    })
      .then(({ success, notifications }) => {
        if (success) {
          toast.success(
            "Solicitação de alteração de CRECI enviada com sucesso"
          );
          onClose();
        } else if (!success && notifications?.length > 0) {
          toast.info(notifications?.[0]?.message);
        } else throw new Error();
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Erro ao solicitar alteração de CRECI, por favor tente novamente"
        );
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const cannotSave = () => {
    if (data.metodoDePagamento === MetodoPagamento.RPA) {
      return !data.nomeDoBanco || !data.agencia || !data.contaCorrente;
    }

    if (data.metodoDePagamento === MetodoPagamento.CNPJ) {
      return (
        !data.cnpj ||
        data.cnpj.length <= 13 ||
        !data.razaoSocial ||
        !data.enderecoFiscal ||
        typeof data.possuiCreciJuridico !== "boolean" ||
        (data.possuiCreciJuridico === true &&
          !data.arquivoCreciJuridico &&
          !user?.autonomoMetodoDePagamento?.arquivoCreciJuridico) ||
        (!data.arquivoCNPJ && !user?.autonomoMetodoDePagamento?.arquivoCNPJ)
      );
    }

    return false;
  };

  return (
    <Styles.DialogContainer open={isOpen} onClose={onClose} maxWidth="lg">
      <Styles.Container>
        <Styles.IconContainer>
          <div className="icon-wrapper">
            <RiEditLine color={COLORS.green} />
          </div>
          <h1 className="title center">{"Método de Pagamento"}</h1>
          <IoClose size={26} className="exit" onClick={onClose} />
        </Styles.IconContainer>

        <S.Form>
          <S.Row template="2.75fr 4.5fr 2.75fr">
            <S.Field>
              <label>{"Método de Pagamento"}</label>
              <SelectComponent
                data={MetodoPagamentoOptions}
                value={data.metodoDePagamento}
                onChange={(val: number) => {
                  if (val !== data.metodoDePagamento) resetMetodoPagamento(val);
                }}
                isError={!data.metodoDePagamento}
                renderLabel
              />
            </S.Field>

            {data.metodoDePagamento === MetodoPagamento.CNPJ && (
              <>
                <S.Field>
                  <label>{"Razão Social"}</label>
                  <TextInput
                    value={data.razaoSocial ?? ""}
                    onChange={(val) => {
                      setData((prev) => ({ ...prev, razaoSocial: val }));
                    }}
                  />
                </S.Field>

                <S.Field>
                  <label>{"CNPJ"}</label>
                  <TextInputMask
                    mask="99.999.999/9999-99"
                    value={data.cnpj ?? ""}
                    onChange={(val: string) => {
                      setData((prev) => ({
                        ...prev,
                        cnpj: rNS(val),
                      }));
                    }}
                  />
                </S.Field>
              </>
            )}

            {data.metodoDePagamento === MetodoPagamento.RPA && (
              <>
                <S.Field>
                  <label>{"Nome do Banco"}</label>
                  <TextInput
                    value={data.nomeDoBanco}
                    onChange={(val) => {
                      setData((prev) => ({ ...prev, nomeDoBanco: val }));
                    }}
                  />
                </S.Field>
                <S.Field>
                  <label>{"N° da Agência com dígito"}</label>
                  <TextInput
                    value={data.agencia}
                    onChange={(val) => {
                      setData((prev) => ({ ...prev, agencia: val }));
                    }}
                  />
                </S.Field>
              </>
            )}
          </S.Row>

          {data.metodoDePagamento === MetodoPagamento.RPA && (
            <S.Row template="1fr">
              <S.Field>
                <label>{"N° da Conta Corrente com dígito"}</label>
                <TextInput
                  value={data.contaCorrente}
                  onChange={(val) => {
                    setData((prev) => ({ ...prev, contaCorrente: val }));
                  }}
                />
              </S.Field>
            </S.Row>
          )}

          {data.metodoDePagamento === MetodoPagamento.CNPJ && (
            <S.Row template="1fr">
              <S.Field>
                <label>{"Endereço CNPJ"}</label>
                <TextInput
                  value={data.enderecoFiscal}
                  onChange={(val) => {
                    setData((prev) => ({ ...prev, enderecoFiscal: val }));
                  }}
                />
              </S.Field>
            </S.Row>
          )}

          {data.metodoDePagamento === MetodoPagamento.CNPJ && (
            <>
              <div style={{ display: "flex", gap: 20, width: "100%" }}>
                <S.Field style={{ maxWidth: "max-content" }}>
                  <label>
                    {"Cartão CNPJ "}
                    <span>{"*"}</span>
                  </label>
                  {user?.autonomoMetodoDePagamento?.arquivoCNPJ ||
                  data.arquivoCNPJ ? (
                    <S.FileHub style={{ width: 200 }}>
                      <IoMdEye
                        size={24}
                        className={`icon ${!!data.arquivoCNPJ && "disabled"}`}
                        onClick={() => {
                          !data.arquivoCNPJ &&
                            handleFileActions(
                              user?.autonomoMetodoDePagamento?.arquivoCNPJ?.url,
                              "open"
                            );
                        }}
                      />
                      <RiEditLine
                        size={24}
                        className="icon"
                        onClick={() => {
                          handleFileUpload("arquivoCNPJ");
                        }}
                      />
                      <RiDownloadLine
                        size={24}
                        className={`icon ${!!data.arquivoCNPJ && "disabled"}`}
                        onClick={() => {
                          !data.arquivoCNPJ &&
                            handleFileActions(
                              user?.autonomoMetodoDePagamento?.arquivoCNPJ?.url,
                              "download"
                            );
                        }}
                      />
                    </S.FileHub>
                  ) : (
                    <SecondaryButton
                      content={uploadButtonContent}
                      style={{ width: 200, height: 44 }}
                      onClick={() => {
                        handleFileUpload("arquivoCNPJ");
                      }}
                    />
                  )}
                </S.Field>
              </div>

              <S.Row template="2.75fr 7.25fr">
                <S.Field>
                  <label>{"Possui CRECI Jurídico"}</label>
                  <SelectComponent
                    data={BooleanOptions}
                    value={data.possuiCreciJuridico}
                    onChange={(val: boolean) => {
                      setData((prev) => ({
                        ...prev,
                        possuiCreciJuridico: val,
                      }));
                    }}
                    isError={typeof data.possuiCreciJuridico !== "boolean"}
                    renderLabel
                  />
                </S.Field>
                <div style={{ display: "flex", gap: 20, width: "100%" }}>
                  {data.possuiCreciJuridico ? (
                    <S.Field style={{ maxWidth: "max-content" }}>
                      <label>
                        {"Certidão CRECI Jurídico "}
                        <span>{"*"}</span>
                      </label>
                      {user?.autonomoMetodoDePagamento?.arquivoCreciJuridico ||
                      data.arquivoCreciJuridico ? (
                        <S.FileHub style={{ width: 200 }}>
                          <IoMdEye
                            size={24}
                            className={`icon ${
                              !!data.arquivoCreciJuridico && "disabled"
                            }`}
                            onClick={() => {
                              !data.arquivoCreciJuridico &&
                                handleFileActions(
                                  user?.autonomoMetodoDePagamento
                                    ?.arquivoCreciJuridico?.url,
                                  "open"
                                );
                            }}
                          />
                          <RiEditLine
                            size={24}
                            className="icon"
                            onClick={() => {
                              handleFileUpload("arquivoCreciJuridico");
                            }}
                          />
                          <RiDownloadLine
                            size={24}
                            className={`icon ${
                              !!data.arquivoCreciJuridico && "disabled"
                            }`}
                            onClick={() => {
                              !data.arquivoCreciJuridico &&
                                handleFileActions(
                                  user?.autonomoMetodoDePagamento
                                    ?.arquivoCreciJuridico?.url,
                                  "download"
                                );
                            }}
                          />
                        </S.FileHub>
                      ) : (
                        <SecondaryButton
                          content={uploadButtonContent}
                          style={{ width: 200, height: 44 }}
                          onClick={() => {
                            handleFileUpload("arquivoCreciJuridico");
                          }}
                        />
                      )}
                    </S.Field>
                  ) : (
                    <div id="dummy" />
                  )}
                </div>
              </S.Row>
            </>
          )}
        </S.Form>

        <S.Buttons style={{ marginTop: 10 }}>
          <div id="dummy" />
          <S.Buttons>
            <SecondaryButton content="Cancelar" onClick={onClose} />
            <PrimaryButton
              content={saving ? <Loading size={18} color="white" /> : "Salvar"}
              onClick={onSubmit}
              disabled={saving || cannotSave()}
            />
          </S.Buttons>
        </S.Buttons>
        <input
          type="file"
          ref={fileInputRef}
          accept={accept}
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
      </Styles.Container>
    </Styles.DialogContainer>
  );
};
